module.exports = __webpack_public_path__ + "static/media/boquilla2.8d9c4378.png";